<template>
  <div>
    <el-table :data="tableData" stripe v-loading="loading" ref="tablePrepost" size="mini" style="width: 100%">
      <el-table-column sortable prop="id" label="Num"></el-table-column>
      <el-table-column sortable prop="name" label="Nome"></el-table-column>
      <el-table-column sortable prop="value" label="Valor">
        <template slot-scope="scope">
          {{ scope.row.value | currency("R$", 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
          }) }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="createdAt" label="Data"></el-table-column>
      <el-table-column width="160" sortable prop="paymentType" :label="$t('tipo')"></el-table-column>
      <el-table-column width="270" align="right">
        <template slot="header" slot-scope="scope">
          <span v-if="tableData.length">
            <el-button type="text" @click="pdf()"><i class="fa fa-file-pdf-o" aria-hidden="true"></i>&nbsp;PDF</el-button>
            <el-button type="text" @click="csv()"><i class="fa fa-file-excel-o" aria-hidden="true"></i>&nbsp;CSV</el-button>
          </span>
        </template>
        <template slot-scope="scope">
          <el-button size="small" title="Visualizar / Imprimir comprovante" icon="el-icon-printer"
            @click="view(scope.$index, scope.row)" circle></el-button>
          <el-button size="small" title="Baixar comprovante de postagem" icon="el-icon-document"
            @click="proof(scope.$index, scope.row)" circle></el-button>
        </template>
      </el-table-column>
    </el-table>
    <PdvPrintDialog :visible.sync="dialog" :proof="pdfProof" :prepost="pdfPrepost" />
  </div>
</template>
<script>
import { PdvDashboardService } from "@/services/pdv/pdv.dashboard.services";
import { PdvService } from "@/services/pdv/pdv.services";
import PdvPrintDialog from "@/xpost/pdv/call/PdvPrintDialog.vue";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "PdvCallListTable",
  components: { PdvPrintDialog },
  props: ["customer", "startedAt", "finishedAt"],
  data() {
    return {
      loading: false,
      tableData: [],
      dialog: false,
      pdfProof: null,
      pdfPrepost: null,
    };
  },
  methods: {
    pdf() {
      this.fetch({
        action: 'export',
        type: 'pdf'
      })
    },
    csv() {
      this.fetch({
        action: 'export',
        type: 'csv'
      })
    },
    proof(index, row) {
      const vm = this;
      vm.loading = true;
      PdvService.proof(row.id, row.key, row.createdBy)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `atendimento.${row.id}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => this.$message({ type: "error", duration: 5000, message: error }))
        .finally(() => vm.loading = false);
    },
    view(index, row) {
      const vm = this;
      vm.loading = true;
      vm.pdfProof = null;
      vm.pdfPrepost = null;
      Promise.all([
        PdvService.proof(row.id, row.key, row.createdBy).catch(() => null),
        PdvService.labels(row.id, row.key, row.createdBy).catch(() => null),
      ])
        .then(([proof, labels]) => {
          vm.pdfProof = proof;
          vm.pdfPrepost = labels;
          if (!proof && !labels) {
            this.$message({ type: "warning", duration: 5000, message: "Nenhum PDF disponível para reimpressão." });
            return;
          }
          vm.dialog = true;
        })
        .catch((error) => this.$message({ type: "error", duration: 5000, message: error }))
        .finally(() => vm.loading = false);
    },
    fetch(options) {
      const vm = this;
      vm.loading = true;
      const s = moment(vm.startedAt);
      const f = moment(vm.finishedAt);
      if (!options) {
        options = {
          action: 'table',
          type: ''
        }
      }
      PdvDashboardService.list(
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
        vm.customer,
        options.action,
        options.type
      )
        .then((response) => {
          if (options.action !== 'export') {
            vm.tableData = response;
            vm.$emit('update', 'call', vm.tableData.length)
          } else {
            var downloadLink = document.createElement("a");
            downloadLink.href = response;
            downloadLink.download = `atendimento.${options.type}`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
          }
        })
        .catch((error) => {
          this.$message({ type: "error", duration: 5000, message: error });
        })
        .finally(() => vm.loading = false);
    },
  },
};
</script>
